/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FlightReservation } from './FlightReservation';
import {
    FlightReservationFromJSON,
    FlightReservationFromJSONTyped,
    FlightReservationToJSON,
    FlightReservationToJSONTyped,
} from './FlightReservation';

/**
 * 
 * @export
 * @interface UserFlightsResponse
 */
export interface UserFlightsResponse {
    /**
     * 
     * @type {Array<FlightReservation>}
     * @memberof UserFlightsResponse
     */
    items: Array<FlightReservation>;
}

/**
 * Check if a given object implements the UserFlightsResponse interface.
 */
export function instanceOfUserFlightsResponse(value: object): value is UserFlightsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function UserFlightsResponseFromJSON(json: any): UserFlightsResponse {
    return UserFlightsResponseFromJSONTyped(json, false);
}

export function UserFlightsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserFlightsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(FlightReservationFromJSON)),
    };
}

export function UserFlightsResponseToJSON(json: any): UserFlightsResponse {
    return UserFlightsResponseToJSONTyped(json, false);
}

export function UserFlightsResponseToJSONTyped(value?: UserFlightsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(FlightReservationToJSON)),
    };
}

